'use strict';

const $ = require('jquery');
require('magnific-popup');

const filter = require('lodash/filter');
const find = require('lodash/find');
const uniqBy = require('lodash/uniqBy');
const orderBy = require('lodash/orderBy');
const isEqual = require('lodash/isEqual');
const map = require('lodash/map');
const isEmpty = require('lodash/isEmpty');

const FuseJS = require('fuse.js');

function controller($scope, $timeout, $attrs, $window, $location, plannerService) {
    let vm = this;

    let allResults = [];
    let allFilters = null;
    let fuse = null;

    vm.totalCount = 0;
    vm.results = [];
    vm.filters = null;
    vm.ticketCount = 2;
    vm.date_filter = {
        from: null,
        to: null,
    };

    vm.showOptions = [];
    vm.selectedShow = null;
    vm.selectedPriceRange = null;
    vm.displayList = false;
    vm.optionFilter = 1;
    vm.selectedOrder = 'best-seats';

    vm.production = 'any show';

    vm.loading = true;
    vm.updating = false;

    vm.updateDates = dateRange => {
        vm.date_filter = dateRange;
    }

    vm.init = function () {
        let url = $location.search();

        plannerService.getPerformancesByPrices().then(response => {
            let productions = uniqBy(response, 'prod_season_no');

            vm.showOptions = productions.map(production => ({
                prodSeasonNo: production.prod_season_no,
                title: production.title
            }));

            allResults = response;
            allFilters = plannerService.generateFacets(response);

            fuse = new FuseJS(allResults, plannerService.fuseOptions);

            const locationFacets = plannerService.locationFacets(allFilters, false);

            const reload = (
                !isEmpty(url) &&
                'count' in url &&
                'event' in url &&
                'pricerange' in url
            );

            vm.selectedOrder = url.order || vm.selectedOrder;

            if (reload) {
                vm.ticketCount = url.count;
                vm.selectedShow = parseInt(url.event, 10) || null;
                vm.selectedPriceRange = (url.pricerange && url.pricerange !== 'null') ? url.pricerange : null;
                vm.optionFilter = (url.filter) ? parseInt(url.filter, 10) : null;

                vm.findTickets();
            }

            if (locationFacets) {
                let order = locationFacets.order;

                if (vm.optionFilter === 1) {
                    vm.selectedOrder = 'best-seats';
                    order = 'best-seats';
                }

                if (vm.optionFilter === 2) {
                    vm.selectedOrder = 'lowest-price';
                    order = 'lowest-price';
                }

                applyFiltering(locationFacets.keyword, locationFacets.filters, order, false);
            } else {
                updateView(allResults);
            }

            // Get a watcher going on keyword input, filters, and order
            $scope.$watch(() => [vm.keyword, vm.filters, vm.selectedOrder, vm.date_filter], processChanges, true);

            // Get a watcher going on location search
            $scope.$watch(() => location.search, processLocation);

            vm.loading = false;
        }, e => {
            console.log(e);

            vm.errorLoading = true;
        }).catch(e => {
            console.log(e);

            vm.errorLoading = true;
        }).finally(function () {
            vm.loading = false;

            $(document).on('click', '.js-type-info', function (e) {
                $.magnificPopup.open({
                    items: {
                        src: e.currentTarget.getAttribute('href'),
                        type: 'inline',
                    }
                });
            });
        });
    }

    vm.increment = function () {
        vm.ticketCount++;
    }

    vm.decrement = function () {
        if (vm.ticketCount === 0) {
            return;
        }

        vm.ticketCount--;
    }

    function filterEvents(filteredEvents)
    {
        if (vm.selectedShow) {
            filteredEvents = filter(filteredEvents, event => {
                return event.prod_season_no === vm.selectedShow && event.avail_count >= vm.ticketCount;
            });

            vm.production = find(vm.showOptions, option => {
                return option.prodSeasonNo === vm.selectedShow;
            });
        } else {
            vm.production = 'any show';
        }

        if (vm.selectedPriceRange) {
            filteredEvents = filterByPriceRange(vm.selectedPriceRange, filteredEvents);
        }

        if (vm.optionFilter === 1) {
            filteredEvents = orderBy(filteredEvents, function (item) {
                return parseFloat(item.price)
            }, ['desc']);
        }

        if (vm.optionFilter === 2) {
            filteredEvents = orderBy(filteredEvents, function (event) {
                return parseFloat(event.price);
            }, ['asc']);
        }

        return filteredEvents;
    }

    vm.findTickets = function() {
        let filteredEvents = allResults;

        if ($attrs.homePage === 'true') {
            let urlParams = 'count=' + vm.ticketCount + '&event=' + vm.selectedShow + '&pricerange=' + vm.selectedPriceRange;

            if (vm.optionFilter) {
                urlParams += '&filter=' + vm.optionFilter;
            }

            $window.location = $attrs.redirectUrl + '?' + urlParams;
        } else {
            filteredEvents = filterEvents(filteredEvents);

            // Figure out what we need to filter!
            const locationFacets = plannerService.locationFacets(vm.filters || allFilters, true);

            let order = locationFacets.order;

            if (vm.optionFilter === 1) {
                order = 'best-seats';
            }

            if (vm.optionFilter === 2) {
                order = 'lowest-price';
            }

            updateView(filteredEvents, [], locationFacets.keyword, order);

            vm.loading = false;
            vm.displayList = true;
        }
    }

    vm.reloadTicketFinder = function () {
        vm.displayList = false;

        map(vm.filters, function (filter) {
            map(filter.keywords, function (keyword) {
                keyword.checked = false;
            });
        });
    }

    function sortList(items, order) {
        if (order === 'best-seats') {
            return orderBy(items, ['price_float'], ['desc']);
        }

        if (order === 'lowest-price') {
            return orderBy(items, ['price_float'], ['asc']);
        }

        if (order === 'date-ascending') {
            return orderBy(items, ['start_date_value'], ['asc']);
        }

        if (order === 'date-descending') {
            return orderBy(items, ['start_date_value'], ['desc']);
        }

        if (order === 'high-availability') {
            return orderBy(items, ['avail_count'], ['desc']);
        }

        if (order === 'low-availability') {
            return orderBy(items, ['avail_count'], ['asc']);
        }

        return items;
    }

    function filterByPriceRange(priceRange, events) {
        if (priceRange === '$0 - $50') {
            return filter(events, item => {
                return parseFloat(item.price) > 0 && parseFloat(item.price) <= 50;
            });
        }

        if (priceRange === '$50 - $100') {
            return filter(events, item => {
                return parseFloat(item.price) > 50 && parseFloat(item.price) <= 100;
            });
        }

        if (priceRange === 'Over $100') {
            return filter(events, item => {
                return parseFloat(item.price) > 100;
            });
        }
    }

    function processChanges(newVal, oldVal) {
        if (!vm.displayList || isEqual(newVal, oldVal) || vm.updating) {
            return false;
        }

        applyFiltering(newVal[0], newVal[1], newVal[2], true);
    }

    function processLocation(newVal, oldVal) {
        // Skip when loading, same values, or updating
        if (!vm.displayList || isEqual(newVal, oldVal) || vm.updating) {
            return false;
        }

        // Figure out what we need to filter!
        const locationFacets = plannerService.locationFacets(vm.filters, true);

        // Use that to apply our filtering
        applyFiltering(locationFacets.keyword, locationFacets.filters, locationFacets.order, false);
    }

    function applyFiltering(keyword, filters, order, updateLocation) {
        // Keep track is updating to prevent watch firing
        vm.updating = true;

        // Grab our items to begin with
        let filteredItems = filterEvents(allResults);

        // Filter by keywords first if possible
        if (keyword && keyword.length) {
            filteredItems = fuse.search(keyword);
        }

        // Now, apply filters
        const result = plannerService.applyFilters({
            filters: filters,
            items: filteredItems
        });

        result.items = result.items.filter(perf => {
            if (!vm.date_filter.start || !vm.date_filter.end) {
                return true;
            }
            return vm.date_filter.start < perf.start_date_moment && vm.date_filter.end > perf.start_date_moment;
        });

        // Update location search on first load
        if (updateLocation) {
            plannerService.updateLocation(keyword, result.facets, order);
        }

        // Update view :3
        updateView(result.items, result.facets, keyword, order);
    }

    function updateView(items, facets, keyword, order) {
        // Keep track is updating to prevent watch firing
        vm.updating = true;

        // Update keyword field if there's one in URL but not in field
        if (vm.keyword !== keyword) {
            vm.keyword = keyword;
        }

        if (!order) {
            order = 'best-seats';
        }

        if (vm.order !== order) {
            vm.order = order;
        }

        // Grab count before grouped
        vm.totalCount = items.length;

        // Sort & assign results
        vm.results = sortList(items, order);

        // Generate filters!
        vm.filters = plannerService.updateFilters({
            filters: vm.filters || allFilters,
            items: items,
            facets: facets || [],
            keyword: keyword
        });

        // Reset updating flag
        $timeout(function () {
            vm.updating = false;
        });
    }

    return vm;
}

module.exports = [
    '$scope',
    '$timeout',
    '$attrs',
    '$window',
    '$location',
    'plannerService',
    controller
];



// WEBPACK FOOTER //
// ./widgets/controllers/TicketFinder.js